import { z } from 'zod';
import { getDefaults } from '@mews/framework';

export const schema = z.object({
    title: z.string().trim().min(1).max(255).default(''),
    note: z.string().max(255).nullish(),
    isReadyToGoLive: z.boolean().default(false),
});

export type FormValues = z.infer<typeof schema>;

export const defaultValues = getDefaults(schema) as FormValues;
